import HeroSection from "@/components/HeroSection";
import AboutPreview from "@/components/AboutPreview";
import HowClassesWork from "@/components/HowClassesWork";
import ProgramsBento from "@/components/ProgramsBento";
import StudentProjects from "@/components/StudentProjects";
import GalleryMasonry from "@/components/GalleryMasonry";
import TestimonialsCarousel from "@/components/TestimonialsCarousel";
import FaqSection from "@/components/FaqSection";
import ContactStrip from "@/components/ContactStrip";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <AboutPreview />
      <HowClassesWork />
      <ProgramsBento />
      <StudentProjects />
      <GalleryMasonry />
      <TestimonialsCarousel />
      <FaqSection />
      <ContactStrip />
    </div>
  );
}
